// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"502":"099844a1","562":"00e50f0f"}[chunkId] + ".chunk.js";
};